
export class Visualizer {
private canvas: any;
private ctx: CanvasRenderingContext2D;
private buffer: AudioBuffer;
private slices = [];
private width: number;
/**
 * @param {?} canvas
 * @param {?} buffer
 */
constructor(canvas: any, buffer: AudioBuffer) {
    this.canvas = canvas.nativeElement;
    this.buffer = buffer;
    this.ctx = this.canvas.getContext('2d');
    this.width = this.canvas.width;
    this.recalculateSlices();
  }
/**
 * @param {?} buffer
 * @return {?}
 */
public updateBuffer(buffer: AudioBuffer): void {
    this.buffer = buffer;
    this.recalculateSlices();
  }
/**
 * @return {?}
 */
public draw(): void {
    if (this.width !== this.canvas.width) {
      this.width = this.canvas.width;
      this.recalculateSlices();
    }
    const /** @type {?} */ WIDTH = this.canvas.width;
    const /** @type {?} */ HEIGHT = this.canvas.height;
    this.ctx.save();
    this.ctx.translate(0, HEIGHT / 2);
    this.ctx.strokeStyle = 'cornflowerblue';
    this.ctx.beginPath();
    for (let /** @type {?} */ i = 0; i < WIDTH; ++i) {
      this.ctx.moveTo(i, Math.floor(this.slices[i][0] * HEIGHT / 2));
      this.ctx.lineTo(i, Math.floor(this.slices[i][1] * HEIGHT / 2));
    }
    this.ctx.stroke();

    this.ctx.strokeStyle = 'cadetblue';
    this.ctx.beginPath();
    this.ctx.moveTo(0, 0);
    this.ctx.lineTo(WIDTH, 0);
    this.ctx.stroke();
    this.ctx.restore();
  }
/**
 * @return {?}
 */
private recalculateSlices(): void {
    this.slices = [];
    const /** @type {?} */ leftChannel = this.buffer.getChannelData(0);
    const /** @type {?} */ binSize = Math.floor(leftChannel.length / this.canvas.width);
    for (let /** @type {?} */ i = 0; i < this.canvas.width; ++i) {
      const /** @type {?} */ slice = leftChannel.slice(i * binSize, (i + 1) * binSize);
      this.slices.push(this.minMax(slice));
    }
  }
/**
 * @param {?} arr
 * @return {?}
 */
private minMax(arr: Float32Array): number[] {
    let /** @type {?} */ min = Infinity;
    let /** @type {?} */ max = -Infinity;
    for (let /** @type {?} */ i = 0; i < arr.length; ++i) {
      if (arr[i] > max) {
        max = arr[i];
      }
      if (arr[i] < min) {
        min = arr[i];
      }
    }
    return [min, max];
  }
}

function Visualizer_tsickle_Closure_declarations() {
/** @type {?} */
Visualizer.prototype.canvas;
/** @type {?} */
Visualizer.prototype.ctx;
/** @type {?} */
Visualizer.prototype.buffer;
/** @type {?} */
Visualizer.prototype.slices;
/** @type {?} */
Visualizer.prototype.width;
}

